import { Alert, Button, ButtonGroup, Tooltip } from "@blueprintjs/core";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import documentosService from "../../services/documentos.service";
import { AuthContext } from '../../utils/context/auth.context.ts';
import { useLocation } from "react-router";
import DocumentViewer from "./docViewer.component.js";

export default function FileInput(props) {
    const {
        id,  // REQUIRED
        name,
        value,
        defaultValue,
        filename,
        filenameFn,
        placeholder,
        disabled,
        title,
        required,
        helpText,
        intent,
        onclick,
        onBlur,
        onFocus,
        onChange,
        onDelete,
        format,
        pattern,
        read,
        data,
        groupData,
        url,
        index,

    } = props
    const { t } = useTranslation();
    const location = useLocation()
    const authContext = useContext(AuthContext)
    const [currentValue, setCurrentValue] = useState(null);
    const [localValidate, setLocalValidate] = useState(false);
    const [isADM] = useState(authContext.isSAD() || authContext.isADM())
    const [alert, setAlert] = useState(false);
    const [fileN] = useState(filenameFn ? filenameFn(props) : filename);
    const seeList = ['PDF', 'JPG', 'JPEG', 'PNG']
    const [ext] = useState(defaultValue ? defaultValue.split('.')[1].toUpperCase() : null)
    const [canSee] = useState(seeList.includes(ext))

    const onBlurHandler = (e) => {
        const value = e.target.value
        if (format) document.getElementById(id).value = format(value);
        if (pattern && value) {
            let isValidPattern = (value).match(pattern)
            if (!isValidPattern) setLocalValidate(true)
            else setLocalValidate(false)
        } else setLocalValidate(false)
        if (onBlur) onBlur(e)
    }

    const onFocusHandler = (e) => {
        if (format) document.getElementById(id).value = (e.target.value).replace(/\D/g, "");
        if (onFocus) onBlur(e)
    }

    const getDefaultValue = () => {
        if (defaultValue && format) return format(defaultValue)
        else if (defaultValue) return defaultValue
        else return ''
    }

    const onChangeHandler = (e) => {
        setCurrentValue((e.target.value).split("\\").at(-1))
        if (e && onChange) onChange(e)
    }

    const onDownloadBtn = (file, name) => {
        if (authContext.verify({ pathname: '/documentos' }, "GET")) {
            documentosService.load(file)
                .then(response => {
                    const contentDisposition = response.headers['content-disposition'];
                    const fileName = contentDisposition.split(';')[1].split('=')[1].replaceAll('"', '');
                    const type = fileName.split('.').pop();
                    const mimeType = `application/${type}`;
                    const data = response.data;
                    const myBlob = new Blob([data]);

                    const blobUrl = window.URL.createObjectURL(myBlob);
                    const link = document.createElement("a");
                    link.href = blobUrl;
                    link.download = name + '.' + type;
                    document.body.appendChild(link);
                    link.click();
                    window.URL.revokeObjectURL(blobUrl);
                })
                .catch(e => {
                    console.error(e);
                });
        }
    }

    return <div className={`bp5-form-group bp5-fill ${intent ? 'bp5-intent-' + intent : ''} ${disabled ? 'disabled' : ''}`}>
        <Alert
            cancelButtonText={t('actions.cancel')}
            confirmButtonText={t('actions.delete')}
            canEscapeKeyCancel={true}
            canOutsideClickCancel={true}
            icon={'trash'}
            intent={'danger'}
            isOpen={alert}
            loading={null}
            onCancel={() => {
                setAlert(false);
            }}
            onConfirm={() => {
                setAlert(false);
                onDelete(defaultValue, id);
            }}
        >
            <p>{t('actions.bodyDelete').replace('%VAR%', fileN)}</p>
        </Alert>

        {title ? <label className="bp5-label" for={id}>
            {title}
            {required ? <span className="bp5-text-muted">{t('actions.required')}</span> : null}
        </label> : null}
        <div className="bp5-form-content">
            <div className={`bp5-input-group bp5-fill ${intent ? 'bp5-intent-' + intent : ''}`}>
                <label className="bp5-file-input">
                    {read ? <input id={id} className="bp5-input-text" name={name} readOnly={true} />
                        : <input id={id} className="bp5-file-input-has-selection" type="file" disabled={disabled || (defaultValue ? true : false)}
                            name={name} onChange={(e) => onChangeHandler(e)}
                        />}
                    <div className="mt-2">
                        <ButtonGroup>
                            {defaultValue && authContext.verify({ pathname: '/documentos' }, "GET") ?
                                <DocumentViewer name={fileN} url={defaultValue || groupData[index]} allowLoad={canSee} ext={ext} />
                                : null}
                            {defaultValue && authContext.verify({ pathname: '/documentos' }, "GET") ?
                                <Tooltip content={t('actions.download')} placement="top">
                                    <Button icon="import" intent='primary' onClick={() => onDownloadBtn(defaultValue, fileN)} />
                                </Tooltip> : null}
                            {defaultValue && authContext.verify({ pathname: '/documentos' }, "DELETE") && isADM ?
                                <Tooltip content={t('actions.delete')} placement="top">
                                    <Button icon="trash" intent='danger' onClick={() => setAlert(true)} />
                                </Tooltip> : null}
                        </ButtonGroup>
                    </div>
                    {read ? null : <span className={`bp5-file-upload-input ${currentValue || defaultValue ? "bp5-file-upload-input-text" : ''}`}>{currentValue || defaultValue ? fileN : placeholder}</span>}

                </label>
            </div>
            {helpText ? <div className="bp5-form-helper-text">{helpText}</div> : null}

        </div>

    </div>


}